<sb-card class="border-0 shadow">
  @if (hasHeader()) {
    <div class="flex h-12 items-center border-0 border-b border-solid border-default border-t-transparent pr-2 pl-4">
      @if (title()) {
        <h3 class="m-0 flex-1 text-base font-semibold text-default">
          {{ title() }}
        </h3>
      }
      <ng-content select="sb-dashboard-widget-select" />
    </div>
  }

  <div class="overflow-y-auto" [class.h-72]="fixedHeight()">
    @if (isLoading()) {
      <sb-loading-state class="size-full" />
    } @else if (isEmpty() && emptySettings()) {
      <sb-empty-state [icon]="emptySettings().icon" [description]="emptySettings().description" class="size-full">
        @if (emptySettings().buttonLabel) {
          <button sb-button [color]="'secondary'" (click)="emptyAction.emit()">
            <sb-icon [name]="'add-regular'" />
            {{ emptySettings().buttonLabel }}
          </button>
        }
      </sb-empty-state>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</sb-card>
